<template>
  <div id="product-list">

    <item-panel v-for="(product, index) in products"
          :key="product.snapshot.id"
          :product="product" @remove="remove(index)" />

    <div id="cart-empty-info" v-if="!products || products.length == 0">
      {{emptyInfo}}
    </div>
  </div>
</template>

<script>
import Langs from '@/langs';

import ItemPanel from './products/ItemPanel';

export default {
  name: 'Main',
  props : ['products'],
  components: {
    ItemPanel
  },
  data () {
    return {
      productDetails : null,
      productDetailsIndex : null,
      emptyInfo: Langs.get('cart-is-empty')
    };
  },
  methods: {
    remove(index) {
      console.log('Removing product', index)
      let prodRemoved = this.products.splice(index, 1)
      this.$emit('removed', prodRemoved.id)
    },
  },
}
</script>

<style lang='less'>
#product-list {
  margin-top: 40px;
}
</style>
